import React from 'react'
import messages from './messages'
import { useIntl } from 'react-intl'
import useLocale from 'js/hooks/useLocale'
import { CmsSourceUrl } from 'typings'
import { LanguageCodes } from 'js/locale'

const imageSources: {
  [key in LanguageCodes]?: { [key: string]: CmsSourceUrl }
} = {
  en: {
    step1:
      'https://www.datocms-assets.com/23496/1671017498-screenshot-diet-plans.png',
    step2:
      'https://www.datocms-assets.com/23496/1671017481-screenshot-diary.png',
    step3:
      'https://www.datocms-assets.com/23496/1724233014-screenshot-lifescore-updated.png',
  },
  de: {
    step1:
      'https://www.datocms-assets.com/23496/1671017490-screenshot-diet-plans-de.png',
    step2:
      'https://www.datocms-assets.com/23496/1671017472-screenshot-diary-de.png',
    step3:
      'https://www.datocms-assets.com/23496/1724232972-screenshot-lifescore-de-updated.png',
  },
}

const HowItWorks = () => {
  const { formatMessage } = useIntl()
  const { language } = useLocale()
  const items = [
    {
      heading: formatMessage(messages.howitworks_1_heading),
      text: formatMessage(messages.howitworks_1_text),
      graphic: imageSources[language]?.['step1'] || imageSources.en?.step1,
    },
    {
      heading: formatMessage(messages.howitworks_2_heading),
      text: formatMessage(messages.howitworks_2_text),
      graphic: imageSources[language]?.['step2'] || imageSources.en?.step2,
    },
    {
      heading: formatMessage(messages.howitworks_3_heading),
      text: formatMessage(messages.howitworks_3_text),
      graphic: imageSources[language]?.['step3'] || imageSources.en?.step3,
    },
  ]

  return (
    <div className="o-width-limiter">
      <div className="grid-cols-3 gap-16 text-center lg:grid">
        {items.map(({ heading, text, graphic }, index) => (
          <div key={index} className="mb-16 md:mb-24">
            <div
              className={`
              mx-auto max-h-[300px]
              max-w-[400px] overflow-hidden md:max-h-[400px] lg:max-h-[275px] xl:md:max-h-[400px] 
            `}
            >
              <div className="relative">
                <picture>
                  <source
                    type="image/webp"
                    srcSet={`${require('media/phone.webp')}, ${require('media/phone@2x.webp')} 2x`}
                  />
                  <source
                    srcSet={`${require('media/phone.png')}, ${require('media/phone@2x.png')} 2x`}
                  />
                  <img src={require('media/phone.png')} alt="" />
                </picture>
                <img
                  className="absolute left-[20%] top-[11%] w-[60%]"
                  src={`${graphic}?auto=format&w=750`}
                  alt=""
                />
              </div>
            </div>
            <h3 className="mb-6 mt-16 block font-demibold">
              <span className="mr-6 inline-block h-[28px] w-[28px] rounded-50% bg-Brand text-center leading-[30px] text-TypeConstant">
                {index + 1}
              </span>
              <span>{heading}</span>
            </h3>
            <p>
              <span>{text}</span>
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default HowItWorks
